import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { SessaoAtivaComponent} from './pages/sessao-ativa-list/sessao-ativa.component';
import { HistoricoAcessoComponent } from './pages/historico-acesso-list/historico-acesso.component';
import { RelatoriosRoutingModule } from './relatorios-routing.module';
import { RelatorioEmailComponent } from './pages/relatorio-email-geral-list/relatorio-email-geral.component';

import { VinculoModule } from "../vinculo/vinculo.module";

@NgModule({
  declarations: [
    SessaoAtivaComponent,
    HistoricoAcessoComponent,
    RelatorioEmailComponent
  ],
  exports:[

  ],
  imports: [
    CommonModule,
    RelatoriosRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgxMaskDirective,
    NgxMaskPipe,
    VinculoModule
],
  providers: [
    provideNgxMask()
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RelatoriosModule {


 }
